// A request can be approved only when m3StatusAnmodan is 3 or lower.
export const isM3StatusValidForSample = (
  m3StatusAnmodan?: number | null,
): boolean => {
  if (m3StatusAnmodan === null || m3StatusAnmodan === undefined) {
    return true;
  }

  if (Number.isNaN(m3StatusAnmodan)) {
    return true;
  }

  return m3StatusAnmodan <= 3;
};